import { createSlice } from '@reduxjs/toolkit'

export const sessionSlice = createSlice({
	name: 'auth/session',
	initialState: {
		accessToken: '',
		refreshToken: '',
        signedIn: false,
		surveyId: 0,
    },
	reducers: {
        onSignInSuccess: (state, action) => {
            state.signedIn = true
			state.accessToken = action.payload.accessToken
			state.refreshToken = action.payload.refreshToken
			state.surveyId = action.payload.surveyId
        },
        onSignOutSuccess: (state) => {
            state.signedIn = false
			state.accessToken = ''
			state.refreshToken = ''
			state.surveyId = 0
        },
        setToken: (state, action) =>  {
			state.accessToken = action.payload.access_token
			state.refreshToken = action.payload.refresh_token
        }
	},
})

export const { onSignInSuccess, onSignOutSuccess, setToken } = sessionSlice.actions

export default sessionSlice.reducer
